import { render, staticRenderFns } from "./ControleConcessionarias.vue?vue&type=template&id=67ce2234&scoped=true&"
import script from "./ControleConcessionarias.vue?vue&type=script&lang=js&"
export * from "./ControleConcessionarias.vue?vue&type=script&lang=js&"
import style0 from "./ControleConcessionarias.vue?vue&type=style&index=0&id=67ce2234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce2234",
  null
  
)

export default component.exports